/* ZOFF form checks -- 30 Oct 2026. Loaded on every page (layout/theme.liquid, both branches).
   Covers the forms that have no script of their own: the footer "Sunday masala note", the Veda waitlist and any
   other customer / contact / account form. The contact page (#contact_form, zoff-contact.js) and the Journal
   newsletter (#sub-form, zoff-blog.js) keep their own checks and are skipped here.
   Shopify's spam protection re-submits a form even after preventDefault, so a failed check also stops the event in
   the CAPTURE phase on document (it runs before that listener). Native required/type stay on the fields as the
   no-JS fallback; the browser's bubble is swapped for an inline message. */
(function () {
  'use strict';
  var SKIP = '#contact_form, #sub-form, [data-no-zf], [role=search]';
  var SCOPE = 'form[action*="/contact"], form[action*="/account"], form[data-zf]';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var LETTERS = /^[A-Za-z\u00C0-\u024F][A-Za-z\u00C0-\u024F .'-]*$/;
  var n = 0;

  function inScope(form) { return form && form.matches && form.matches(SCOPE) && !form.matches(SKIP); }
  function fields(form) {
    return Array.prototype.filter.call(form.elements, function (el) {
      return el.name && !el.disabled && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) && !/^(hidden|submit|button|checkbox|radio|range)$/.test(el.type);
    });
  }
  function mobile(v) { var d = v.replace(/\D/g, ''); if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2); else if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1); return d; }
  function rule(el) {
    var v = el.value.trim(), name = (el.name || '').toLowerCase(), isMail = el.type === 'email' || name.indexOf('email') > -1;
    if (!v) return el.required ? (el.getAttribute('data-msg-required') || (isMail ? 'Enter your email address.' : 'Please fill this in.')) : true;
    if (isMail) return EMAIL.test(v) || 'Enter an email like name@example.com.';
    if (el.type === 'tel' || name.indexOf('phone') > -1) { var d = mobile(v); return (/^[6-9]\d{9}$/.test(d) && !/^(\d)\1{9}$/.test(d)) || 'Enter a valid 10-digit mobile number.'; }
    if (/(^|\[)(name|first_name|last_name)\]?$/.test(name) || name.indexOf('[name]') > -1) return (LETTERS.test(v) && v.length >= 2 && v.length <= 60) || 'Use letters only, at least 2.';
    if (el.minLength > 0 && v.length < el.minLength) return 'Please enter at least ' + el.minLength + ' characters.';
    if (el.pattern) { try { if (!new RegExp('^(?:' + el.pattern + ')$').test(v)) return el.title || 'Please match the requested format.'; } catch (_) {} }
    return true;
  }
  function errFor(el, make) {
    var id = el.getAttribute('data-zf-err'), box = id && document.getElementById(id);
    if (box || !make) return box;
    box = document.createElement('p');
    box.className = 'zf-err'; box.id = 'zf-err-' + (++n); box.setAttribute('aria-live', 'polite');
    el.setAttribute('data-zf-err', box.id);
    el.form.appendChild(box); // last in the form: under the row in flex forms, under the field in stacked ones
    return box;
  }
  function show(el, res) {
    var ok = res === true, box = errFor(el, !ok);
    if (ok) { el.removeAttribute('aria-invalid'); if (box) box.textContent = ''; return true; }
    el.setAttribute('aria-invalid', 'true');
    var d = (el.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    if (d.indexOf(box.id) < 0) { d.push(box.id); el.setAttribute('aria-describedby', d.join(' ')); }
    box.textContent = res;
    return false;
  }
  function validate(form) {
    var first = null;
    fields(form).forEach(function (el) { if (!show(el, rule(el)) && !first) first = el; });
    return first;
  }

  var css = document.createElement('style');
  css.textContent = '.zf-err{flex-basis:100%;width:100%;margin:8px 0 0;font:600 14px/1.4 "Space Grotesk",system-ui,sans-serif;color:#C8371F}' +
    '.zf-err:empty{display:none}' +
    'form [aria-invalid="true"]{border-color:#E5484D!important;box-shadow:0 0 0 2px rgba(229,72,77,.25)!important}' +
    '.zs-ft .zf-err{color:#FFB199}' +
    '@keyframes zfShake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}30%,50%,70%{transform:translateX(-4px)}40%,60%{transform:translateX(4px)}}' +
    'form.zf-shake{animation:zfShake .4s ease}@media (prefers-reduced-motion:reduce){form.zf-shake{animation:none}}';
  document.head.appendChild(css);

  // the browser's own required/type checks: our message instead of its bubble
  document.addEventListener('invalid', function (e) {
    var el = e.target; if (!el.form || !inScope(el.form)) return;
    e.preventDefault(); show(el, rule(el) === true ? (el.validationMessage || 'Please check this field.') : rule(el));
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!inScope(form)) return;
    var bad = validate(form);
    if (!bad) return;
    e.preventDefault(); e.stopImmediatePropagation();
    form.classList.remove('zf-shake'); void form.offsetWidth; form.classList.add('zf-shake');
    bad.focus();
  }, true);
  // after the first look at a field: blur checks it, typing clears the error as soon as it is right
  document.addEventListener('blur', function (e) {
    var el = e.target; if (!el.form || !inScope(el.form) || !el.name || !el.value) return;
    if (fields(el.form).indexOf(el) > -1) show(el, rule(el));
  }, true);
  document.addEventListener('input', function (e) {
    var el = e.target; if (!el.form || !inScope(el.form) || el.getAttribute('aria-invalid') !== 'true') return;
    show(el, rule(el));
  }, true);
  // right keyboard + caps on fields that do not set them
  function tune(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(SCOPE), function (form) {
      if (form.matches(SKIP)) return;
      fields(form).forEach(function (el) {
        var name = (el.name || '').toLowerCase();
        if (el.type === 'email' || name.indexOf('email') > -1) { if (!el.maxLength || el.maxLength < 0) el.maxLength = 100; if (!el.inputMode) el.inputMode = 'email'; }
        else if (el.type === 'tel' || name.indexOf('phone') > -1) { if (!el.maxLength || el.maxLength < 0) el.maxLength = 15; if (!el.inputMode) el.inputMode = 'tel'; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tune(); }); else tune();
})();
